import { render, staticRenderFns } from "./LabelView.vue?vue&type=template&id=6920a7d0&scoped=true&"
import script from "./LabelView.vue?vue&type=script&lang=js&"
export * from "./LabelView.vue?vue&type=script&lang=js&"
import style0 from "./LabelView.vue?vue&type=style&index=0&id=6920a7d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920a7d0",
  null
  
)

component.options.__file = "LabelView.vue"
export default component.exports